import React from "react";
import Delivered from "../../../assets/svg/icons/Delivered";
import InTransit from "../../../assets/svg/icons/InTransit";
import ShippingPending from "../../../assets/svg/icons/ShippingPending";

const STATUS_ORDERED = "Ordered";
const STATUS_SHIPPING = "Shipping";
const STATUS_SHIPPED = "Shipped";

const normalizeStatus = (status) => {
  const s = (status || "").toLowerCase();
  if (s === "shipped") return STATUS_SHIPPED;
  if (s === "shipping") return STATUS_SHIPPING;
  if (s === "ordered") return STATUS_ORDERED;
  return STATUS_ORDERED;
};

export const getStatusBadgeContent = (status) => {
  const normalized = normalizeStatus(status);

  if (normalized === STATUS_SHIPPED) {
    return { icon: <Delivered />, text: STATUS_SHIPPED, variant: "shipped" };
  }
  if (normalized === STATUS_SHIPPING) {
    return { icon: <InTransit />, text: STATUS_SHIPPING, variant: "shipping" };
  }
  return { icon: <ShippingPending />, text: STATUS_ORDERED, variant: "ordered" };
};
